module.exports = __webpack_public_path__ + "img/26-produtividade-geral-lista.aa7a5789.png";